import React, { useState, useContext, useMemo, useCallback, useEffect } from "react";
import {useLocation, useHistory} from "react-router-dom";
import {connect} from "react-redux";
import Modal from "react-bootstrap/Modal";
import {IconButton} from "@material-ui/core";
import Search from "@material-ui/icons/Search";

import { DrawerProvider } from "../../../contexts/drawer/drawer.provider";
import { AuthContext } from "../../../contexts/auth/auth.context";
import {SearchContext} from "../../../contexts/search/search.context";
import {HeaderContext} from "../../../contexts/header/header.context";
import {useCart} from "../../../contexts/cart/use-cart";
import {useStoreLogo} from "../../../contexts/store-logo/use-storeLogo";
import MobileDrawer from "./MobileDrawer";
import {
  MobileHeaderWrapper,
  MobileHeaderInnerWrapper,
  DrawerWrapper,
  LogoWrapper,
  SearchWrapper,
  SearchModalWrapper,
  SearchModalClose,
} from "./Header.style";
import NotificationPopUp from "../../../components/Notification/NotificationPopUp";
import SearchBox from "../../../components/SearchBox/SearchBox";
import {LongArrowLeft} from "../../../components/AllSvgIcon";
import Logo from "../../../components/Logo/Logo";
import { isCategoryPage } from "../is-home-page";
import useDimensions from "../../../helper/useComponentSize";
import {
	RightMenuBox,
	AccountContainer,
	RegisterContainer,
	CartContainer,
	CartIcon,
	CartLabel,
	BadgeContainer,
	LabelContainer,
} from "../Header/Menu/RightMenu/RightMenu.style";
import {Basket} from "../../../assets/icons/Basket";
import {
  searchStoreProduct,
  searchSuggestions,
  Reset_Suggestions,
  Toggle_Suggestions,
  getProductsMappedwithCat,
  getProductsMappedwithSubCat,
  getProductOutOfStockCat,
  getProductOutOfStock,
  changePage,
	resetPage,
	sortProducts,
} from "../../../store/actions/productAction";
import {
  changeNotificationPage,
  resetNotificationPage,
  getAllNotifications,
  getCountUnreadNotifications,
	markAllAsRead,
} from "../../../store/actions/notificationAction";
import {initExpressStoreProducts} from "../../../store/actions/expressAction";
import deliExpressLogo from "../../../assets/icons/delixpress_logo2.svg";
import deliShopLogo from "../../../assets/icons/delishop_logo2.svg";

const SearchModal = ({props, onHide, searchShow}) => {
  const { state, searchdispatch } = useContext(SearchContext);
	const [text, setText] = useState("");
	const {pathname} = useLocation();

	const handleSearchInput = useCallback((text) => {
    setText(text);
		if (props.all_suggested_subcats.length !== 0) {
      props.Reset_Suggestions();
    }
	}, [props.all_suggested_subcats, props.Reset_Suggestions]);

	useEffect(() => {
		if (searchShow) {
			window.scrollTo({top: 0});
			// Initialize with existing search query from localStorage or SearchContext
			const savedSearchQuery = localStorage.getItem("search_query") || state.text || "";
			// Decode URL-encoded characters (e.g., %20 -> space)
			let decodedQuery = savedSearchQuery;
			try {
				decodedQuery = decodeURIComponent(savedSearchQuery);
			} catch (e) {
				// If decoding fails, use the original query
				decodedQuery = savedSearchQuery;
			}
			setText(decodedQuery);
			props.Toggle_Suggestions({toggle: false});
		} else {
			// Clear text when modal closes
			setText("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchShow]);

	useEffect(() => {
		if (text !== "" && text.length >= 3) {
			searchdispatch({
				type: "UPDATE",
				payload: {
					text,
				},
			});
		}
	}, [text, searchdispatch]);

	const handleClickSearchButton = useCallback(() => {
		if (text !== "" && text.length >= 3) {
	    localStorage.setItem("sub_cat_id", -1);
	    localStorage.setItem("subcatname", "");
			localStorage.setItem("search_query", text);
			window.location.href = `/search/${encodeURIComponent(text)}`;
			props.searchSuggestions({search_query: text?.trim(), store_id: 1});
    }
	}, [text, props]);

  return (
    <SearchModalWrapper>
	    <SearchModalClose type="submit" onClick={onHide} id="closeModal">
        <LongArrowLeft />
      </SearchModalClose>
      <SearchBox
        className="header-modal-search"
        suggestions={props.all_suggested_subcats}
        bordered={false}
        inputStyle={{ height: 35 }}
        buttonText=""
        placeholder="Search"
        handleSearch={handleSearchInput}
        value={text}
        onClick={handleClickSearchButton}
        pathname={pathname}
        props={props}
      />
    </SearchModalWrapper>
  );
};

const MobileHeader = (props, {className}) => {
	const {state} = useContext(SearchContext);
  const { storeLogo, fetchStoreLogo } = useStoreLogo();
  const { headerDispatch } = useContext(HeaderContext);
	const {authState: {isAuthenticated}} = useContext(AuthContext);
	const {calculatePrice, items} = useCart();

	const [mobileHeaderRef, dimensions] = useDimensions();
  const [searchShow, setSearch] = useState(false);

	const headerHeight = useMemo(() => dimensions.height, [dimensions.height]);

	const totalCartItemsCount = useMemo(() =>
			items.reduce((acc, item) => acc + item.quantity, 0),
		[items]
	);

	const isHomePage = useMemo(() =>
			isCategoryPage(window.location.pathname) &&
			window.location.pathname.indexOf("not-found") === -1,
		[]
	);

	useEffect(() => {
    headerDispatch({
      type: "GET_MOBILE_HEIGHT",
      payload: {
        ...state,
        mobileHeight: headerHeight,
      },
    });
	}, [headerHeight, headerDispatch, state]);

	useEffect(() => {
    fetchStoreLogo();
  }, [fetchStoreLogo]);


	const handleSearchClick = useCallback(() => {
		setSearch(true);
	}, []);

	const handleCloseSearch = useCallback(() => {
		setSearch(false);
	}, []);

	const handleCartClick = useCallback(() => {
		const productCart = document.getElementsByClassName("product-cart")[0];
		if (productCart) {
			productCart.click();
			productCart.style.visibility = "visible";
		}
  }, []);

	const logoUrl = useMemo(() =>
			props.cartType === "express"
				? storeLogo?.express ?? deliExpressLogo
				: storeLogo?.normal ?? deliShopLogo,
		[props.cartType, storeLogo]
	);

	const searchWrapperStyle = useMemo(() => ({
		marginRight: isAuthenticated ? "auto" : "5px",
		marginLeft: isAuthenticated ? "15px" : "auto",
	}), [isAuthenticated]);

	const showCart = useMemo(() => {
		return isAuthenticated;
	}, [isAuthenticated]);

  return (
    <DrawerProvider>
      <MobileHeaderWrapper>
        <MobileHeaderInnerWrapper className={className} ref={mobileHeaderRef}>
          <DrawerWrapper>
            <MobileDrawer id="mobilesidebar" />
          </DrawerWrapper>

	        {isHomePage && (
            <SearchWrapper
              className="searchIconWrapper"
              style={searchWrapperStyle}
            >
	            <IconButton onClick={handleSearchClick} aria-label="Search products">
		            <Search size="large" style={{width: "30px"}}/>
              </IconButton>
            </SearchWrapper>
	        )}

          <LogoWrapper>
	          <Logo
		          imageUrl={logoUrl}
		          alt="shop logo"
		          height={55}
		          width={120}
		          cartType={props.cartType}
	          />
          </LogoWrapper>

          <div className="d-flex align-items-center">
	          {isAuthenticated && (
		          <NotificationPopUp props={props} isHomePage={isHomePage}/>
	          )}

	          {showCart && (
		          <CartContainer
			          className="cart-container"
			          style={{marginRight: "5px"}}
			          onClick={handleCartClick}
		          >
			          <CartIcon>
				          <Basket cartType={props.cartType}/>
				          <BadgeContainer className={props.cartType}>
					          {totalCartItemsCount}
				          </BadgeContainer>
			          </CartIcon>
			          <CartLabel>
				          <LabelContainer className={props.cartType}>
					          ${calculatePrice()}
				          </LabelContainer>
			          </CartLabel>
		          </CartContainer>
	          )}
          </div>
          <Modal
            show={searchShow}
            onHide={handleCloseSearch}
            dialogClassName="modal-90w authModal"
            aria-labelledby="mobile-search-modal"
          >
            <Modal.Body style={{ padding: 0 }}>
              <SearchModal
                props={props}
                onHide={handleCloseSearch}
                searchShow={searchShow}
              />
            </Modal.Body>
          </Modal>
        </MobileHeaderInnerWrapper>
      </MobileHeaderWrapper>
    </DrawerProvider>
  );
};
const mapStateToProps = (state) => {
  return {
    success: state,
    allproducts: state.productReducer.allproducts,
    products: state.productReducer.products,
    suggested_subcats: state.productReducer.suggested_subcats,
    all_suggested_subcats: state.productReducer.all_suggested_subcats,
    togglesuggestion: state.productReducer.togglesuggestion,
    page: state.productReducer.page,
    min: state.productReducer.min,
    max: state.productReducer.max,
    sort: state.productReducer.sort,
    priority: state.productReducer.priority,
    oos: state.productReducer.oos,
    brand_id: state.productReducer.brand_id,
    cat_id: state.productReducer.cat_id,
    cat_id_18: state.productReducer.cat_id_18,
    sub_cat_id: state.productReducer.sub_cat_id,
    sub_cat_18: state.productReducer.sub_cat_18,
    country_id: state.productReducer.country_id,
    cartType: state.cartReducer.cartType,
    storeSelected: state.expressReducer.storeSelected,
    filteredProducts: state.productReducer.filteredProducts,
    notifications: state.notificationReducer.notifications,
    notification_page: state.notificationReducer.page,
    notifcation_loading: state.notificationReducer.loading,
    unread_notification: state.notificationReducer.unread_notification,
    has_more: state.notificationReducer.has_more,
    suggestionItems: state.productReducer.suggestionItems,
    // modalData :state.productReducer.modalData,
    // user_address: state.userReducer.address
    suggestion_loading: state.productReducer.suggestion_loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchStoreProduct: (data) => searchStoreProduct(data, dispatch),
    searchSuggestions: (data) => searchSuggestions(data, dispatch),
    getProductsMappedwithSubCat: (data) =>
      getProductsMappedwithSubCat(data, dispatch),
    getProductsMappedwithCat: (data) => getProductsMappedwithCat(data, dispatch),
    getProductOutOfStock: (body) => getProductOutOfStock(body, dispatch),
    getProductOutOfStockCat: (body) => getProductOutOfStockCat(body, dispatch),
    Reset_Suggestions: () => Reset_Suggestions(dispatch),
    Toggle_Suggestions: (data) => Toggle_Suggestions(data,dispatch),
    changePage: (body) => changePage(body, dispatch),
    resetPage: () => resetPage(dispatch),

    initProductExpressStore: (data) => initExpressStoreProducts(data, dispatch),
    sortProducts: (data) => sortProducts(data, dispatch),
    getAllNotifications: (data) => getAllNotifications(data, dispatch),
    getCountUnreadNotifications: () => getCountUnreadNotifications(dispatch),
    markAllAsRead: () => markAllAsRead(dispatch),
    changeNotificationPage: (data) => changeNotificationPage(data, dispatch),
    resetNotificationPage: () => resetNotificationPage(dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MobileHeader);
// export default MobileHeader;
